// === typing ==
export const IS_TYPING = 'typing in a conversation'
export function isTyping(room, timeoutId) {
  return {
    type: IS_TYPING,
    room: room,
    timeoutId: timeoutId
  }
}

export const STOP_TYPING = 'typing stop in a conversation'
export function stopTyping(room) {
  return {
    type: STOP_TYPING,
    room: room
  }
}

// === Set conversation payload ==
export const SET_INFO = 'V2/CONVERSATION_SET_INFO'
export function setInfo(room, payload) {
  return {
    type: SET_INFO,
    room: room,
    payload: payload,
  }
}
export const SETS_INFO = 'set info to a list of conversations'
export function setsInfo(conversations) {
  return {
    type: SETS_INFO,
    conversations: conversations,
  }
}

export const SET_TYPE = 'V2/CONVERSATION_SET_TYPE'
export function setType(room, conversationType) {
  return {
    type: SET_TYPE,
    room: room,
    conversationType: conversationType,
  }
}

export const SETS_TYPE = 'set type to a list of conversation'
export function setsType(rooms, conversationType) {
  return {
    type: SETS_TYPE,
    rooms: rooms,
    conversationType: conversationType,
  }
}

export const SET_META_INFO = 'conversation set meta info'
export function setMetaInfo(room, info) {
  return {
    type: SET_META_INFO,
    room: room, info: info
  }
}


export const SET_PARTICIPANT_READ= 'conversation set a particpant to read'
export function setParticipantRead(room, participantId) {
  return {
    type: SET_PARTICIPANT_READ,
    room: room, participantId: participantId.toString()
  }
}

export const SET_READ= 'conversation set read'
export function setRead(room, read) {
  return {
    type: SET_READ,
    room: room, read: read
  }
}
export const SETS_READ= 'conversations set read'
export function setsRead(reads) {
  return {
    type: SETS_READ,
    reads: reads
  }
}


// === Read room entries action==
export const READ_ENTRIES_REQUEST = 'V2/CONVERSATION_READ_ENTRIES_REQUEST'
export function readEntriesRequest(room) {
    return {
        type: READ_ENTRIES_REQUEST,
        room: room,
    }
}

export const READ_ENTRIES_SUCCESS = 'V2/CONVERSATION_READ_ENTRIES_SUCCESS'
export function readEntriesSuccess(room, entries, fetchPrevious) {
    return {
        type: READ_ENTRIES_SUCCESS,
        room: room,
        entries: entries
    }
}

export const CREATE_TAG_SUCCESS = 'CREATE_TAG_SUCCESS'
export function createTagSuccess(room, tags) {
    return {
        type: CREATE_TAG_SUCCESS,
        room: room,
        tags: tags
    }
}

export const DELETE_TAG_SUCCESS = 'DELETE_TAG_SUCCESS'
export function deleteTagSuccess(room, tags) {
    return {
        type: DELETE_TAG_SUCCESS,
        room: room,
        tags: tags
    }
}

export const CREATE_TAG_FAILURE = 'CREATE_TAG_FAILURE'
export function createTagFailure(room, tag) {
    return {
        type: CREATE_TAG_FAILURE,
        room: room,
        tag: tag
    }
}

export const READ_ENTRIES_FAILURE = 'V2/CONVERSATION_READ_ENTRIES_FAILURE'
export function readEntriesFailure(err, res) {
    return {
        type: READ_ENTRIES_FAILURE,
        error: err,
        response: res,
    }
}

export const ADD_UNCONFIRMED_ENTRY = 'V2/CONVERSATION_ADD_UNCONFIRMED_ENTRY'
export function addUnconfirmedEntry(room, entry, entryRandomId) {
  return {
    type: ADD_UNCONFIRMED_ENTRY,
    room: room,
    entry: entry,
    entryRandomId: entryRandomId
  }
}

export const PUT_CONFIRMED_ENTRIES = 'V2/CONVERSATION_PUT_CONFIRMED_ENTRIES'
export function putConfirmedEntries(room, entries) {
  return {
    type: PUT_CONFIRMED_ENTRIES,
    room: room,
    entry: entries,
  }
}

export const ADD_CONFIRMED_ENTRY = 'V2/CONVERSATION_ADD_CONFIRMED_ENTRY'
export function addConfirmedEntry(room, entry) {
  return {
    type: ADD_CONFIRMED_ENTRY,
    room: room,
    entry: entry,
  }
}

export const UPDATE_ENTRY = 'update an entry'
export function updateEntry(room, entry) {
  return {
    type: UPDATE_ENTRY,
    room: room,
    entry: entry,
  }
}
export const ADD_BULK_ENTRIES = 'add bulk of entries to list of conversation'
export function addBulkEntries(entries) {
  return {
    type: ADD_BULK_ENTRIES,
    entries: entries
  }
}

export const SET_ENTRY_TO_CONFIRMED = 'V2/CONVERSATION_SET_ENTRY_TO_CONFIRMED'
export function setEntryToConfirmed(room, entryRandomId) {
  return {
    type: SET_ENTRY_TO_CONFIRMED,
    room: room,
    entry: entryRandomId,
  }
}

export const REMOVE_ENTRIES= 'remove current entries in conversation'
export function removeEntries(room) {
  return {
    type: REMOVE_ENTRIES,
    room: room,
  }
}

export const DELETE_CONVERSATION= 'remove conversation'
export function deleteConversation(room) {
  return {
    type: DELETE_CONVERSATION,
    room: room,
  }
}



// WEBPACK FOOTER //
// ./src/model/Conversation/actions.js